import { Component, OnInit } from '@angular/core';
import {ActivatedRoute} from "@angular/router";
import {take} from "rxjs/operators";

@Component({
  selector: 'app-authenticated-videocall-closed-page',
  templateUrl: './authenticated-videocall-closed-page.component.html',
  styleUrls: ['./authenticated-videocall-closed-page.component.scss']
})
export class AuthenticatedVideocallClosedPageComponent implements OnInit {

  logo: string;
  color: string;

  constructor(
    private route: ActivatedRoute,
  ) { }

  ngOnInit(): void {
    this.route.queryParamMap.pipe(take(1)).subscribe(async queryParamMap => {
      this.logo = queryParamMap.get('logo');
      this.color = queryParamMap.get('color');
    });
  }

}
